import { render, staticRenderFns } from "./NymTerms.vue?vue&type=template&id=ffba7fd8&"
import script from "./NymTerms.vue?vue&type=script&lang=js&"
export * from "./NymTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports